import Home from "../pages/home/Home";
import Vendor from "../pages/vendor/Vendor";
import Services from "../pages/services/Services";
import Events from "../pages/events/Events";
import Blogs from "../pages/blogs/Blogs";
import BlogDetail from "../pages/blogdetail/BlogDetail";
import ContactUs from "../pages/contactus/ContactUs";
import PartnerWithUs from "../pages/partnerWithUs/PartnerWithUs";
import About from "../pages/about/About";

import VendorDetail from "../pages/vendorDetail/VendorDetail";
import TermsOfServices from "../pages/termsOfServices/TermsOfServices";
import PrivacyPolicy from "../pages/privacy/PrivacyPolicy";
export const routesData = [
  {
    id: 0,
    path: "/",
    component: <Home />,
  },

  {
    id: 3,
    path: "/vendors",
    component: <Vendor />,
  },
  {
    id: 33,
    path: "/vendors/:slug",
    component: <VendorDetail />,
  },
  {
    id: 1,
    path: "/services",
    component: <Services />,
  },
  {
    id: 7,
    path: "/events",
    component: <Events />,
  },

  {
    id: 8,
    path: "/partnerwithus",
    component: <PartnerWithUs />,
  },

  {
    id: 4,
    path: "/blog",
    component: <Blogs />,
  },
  {
    id: 5,
    path: "/blog/:slug",
    component: <BlogDetail />,
  },
  {
    id: 6,
    path: "/contactus",
    component: <ContactUs />,
  },
  {
    id: 6,
    path: "/about",
    component: <About />,
  },

  // {
  //   id:7,
  //   path:"/terms_of_services",
  //   component:<TermsOfServices />
  // },
  // {
  //   id:8,
  //   path:"/privacy_policy",
  //   component:<PrivacyPolicy />
  // }
];
